import request from '@/util/request';
import qs from 'qs';

// 分页列表
export const getPageListApi = (params, options) =>
  request.get('/api/v4ward/callcenter/server/page', Object.assign({}, options, { params }));

// 新增
export const addApi = (params, options) =>
  request.post('/api/v4ward/callcenter/server/save', params, options, {
    'Content-Type': 'application/json',
  });

// 批量删除
export const delApi = (params, options) =>
  request.post('/api/v4ward/callcenter/server/remove', qs.stringify(params), options);

// 离席
export const awayApi = (params, options) =>
  request.post('/api/v4ward/callcenter/server/leave', params, options, {
    'Content-Type': 'application/json',
  });

// 下号|离线|签退
export const logoutApi = (params, options) =>
  request.post('/api/v4ward/callcenter/server/logout', params, options, {
    'Content-Type': 'application/json',
  });

// 更换绑定
export const bindApi = (params, options) =>
  request.post('/api/v4ward/callcenter/server/update', params, options, {
    'Content-Type': 'application/json',
  });
